// extracted by mini-css-extract-plugin
export var lightbox_btn_close = "lightbox-module--lightbox_btn_close--2Y66a";
export var lightbox_container = "lightbox-module--lightbox_container--1_tTg";
export var lightbox_content = "lightbox-module--lightbox_content--3SYys";
export var lightbox_title = "lightbox-module--lightbox_title--23LZ8";